import { DakokuService } from "@/service/DakokuService"
import { RecalcDakokByDakokuInfo } from "@/types/Dakoku"
import { computed, Ref, ref } from "vue"

/*
 * 打刻保存
 */
export function useDakoku() {
  let loading = ref(0)
  let isError = ref(false)
  const dakokuService = new DakokuService()

  const getDakokuData = async (syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null) => {
    loading.value++
    const res = await dakokuService.getDakokuData(syuugyouBasyoId, koyouKeiyakuId, koyouKeiyakuTimeId)
    loading.value--
    return res
  }

  // 出勤打刻
  const syukkin = async (syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null) => {
    loading.value++
    const res = await dakokuService.syukkin(syuugyouBasyoId, koyouKeiyakuId, koyouKeiyakuTimeId)
    loading.value--
    return res
  };

  // 外出打刻
  const gaisyutsu = async (syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null) => {
    loading.value++
    const res = await dakokuService.gaisyutsu(syuugyouBasyoId, koyouKeiyakuId, koyouKeiyakuTimeId)
    loading.value--
    return res
  };

  // 戻り打刻
  const modori = async (syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null) => {
    loading.value++
    const res = await dakokuService.modori(syuugyouBasyoId, koyouKeiyakuId, koyouKeiyakuTimeId)
    loading.value--
    return res
  };

  // 退勤打刻
  const taikin = async (syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null) => {
    loading.value++
    const res = await dakokuService.taikin(syuugyouBasyoId, koyouKeiyakuId, koyouKeiyakuTimeId)
    loading.value--
    return res
  };

  // 休憩時間の登録
  const kyuukei = async (targetDate: Date, kyuukeiTimes: string, syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null) => {
    loading.value++
    const res = await dakokuService.kyuukei(targetDate, kyuukeiTimes, syuugyouBasyoId,  koyouKeiyakuId, koyouKeiyakuTimeId)
    loading.value--
    return res
  };

  // 打刻コメントの登録
  const honninNotes = async (targetDate: Date | string, honninNotes: string, syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null) => {
    loading.value++
    const res = await dakokuService.honninNotes(targetDate, honninNotes, syuugyouBasyoId, koyouKeiyakuId, koyouKeiyakuTimeId)
    loading.value--
    return res
  };

  // 打刻承認
  const dakokuSyounin = async (dakokuId: number, syouninStatusType: number, syouninStatusNotes: string) => {
    loading.value++
    const res = await dakokuService.dakokuSyounin(dakokuId, syouninStatusType, syouninStatusNotes)
    loading.value--
    return res
  };

  // 打刻再計算
  const recalcDakokuByDakokuInfos = async (dakokuInfos: RecalcDakokByDakokuInfo[], force: boolean = false) => {
    loading.value++
    const res = await dakokuService.recalcDakokuByDakokuInfos(dakokuInfos, force)
    loading.value--
    return res
  };


  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  return {
    getDakokuData,
    syukkin,
    gaisyutsu,
    modori,
    taikin,
    kyuukei,
    dakokuSyounin,
    isLoading,
    honninNotes,
    recalcDakokuByDakokuInfos
  }
}
